export const countOpenMaterials = (students, currentEmail) => {
  const student = students.find(student => student.email === currentEmail);

  if (student && student.materials) {
    const count = Object.values(student.materials).reduce((count, material) => {
      if (material.materialOpen) {
        return count + 1;
      }
      return count;
    }, 0);
    return count;
  }

  return 0;
};

export const countsDzExamsStudents = (students, currentEmail) => {
  const student = students.find(student => student.email === currentEmail);
  const result = {
    cl: 0,
    dz: 0,
    total: 0,
    clPercentage: 0,
    dzPercentage: 0,
  };

  if (student) {
    if (student.materials) {
      Object.values(student.materials).forEach(material => {
        if (
          material.courseCompletion &&
          typeof material.courseCompletion === 'object' &&
          'student' in material.courseCompletion &&
          material.courseCompletion.studentCheked === true
        ) {
          result.cl += 1;
        }
      });
    }

    if (student.homeworks) {
      Object.values(student.homeworks).forEach(homework => {
        if (homework.subItems === true && homework.subArrayCheckeds.every(Boolean)) {
          result.dz += 1;
        } else if (homework.completed === true) {
          result.dz += 1;
        }
      });
    }

    result.total = result.cl + result.dz;

    if (result.total > 0) {
      result.clPercentage = Math.round((result.cl / result.total) * 100).toString();
      result.dzPercentage = Math.round((result.dz / result.total) * 100).toString();
    }
  }

  return result;
};

export const addedFilesStudents = (students, currentEmail) => {
  const student = students.find(student => student.email === currentEmail);
  const sums = {
    homeworksPhotosSum: 0,
    materialsFilesSum: 0,
  };

  if (student) {
    if (student.homeworks) {
      Object.values(student.homeworks).forEach(homework => {
        if (Array.isArray(homework.studentPhotos)) {
          // Если studentPhotos массив, считаем все вложенные массивы
          sums.homeworksPhotosSum += homework.studentPhotos.flat(Infinity).length;
        } else if (typeof homework.studentPhotos === 'object') {
          // Если studentPhotos объект, считаем длину всех свойств-массивов
          Object.values(homework.studentPhotos).forEach(array => {
            if (Array.isArray(array)) {
              sums.homeworksPhotosSum += array.length;
            }
          });
        }
      });
    }

    if (student.materials) {
      Object.values(student.materials).forEach(material => {
        if (Array.isArray(material.chapter)) {
          material.chapter.forEach(chapterItem => {
            if (Array.isArray(chapterItem.points)) {
              chapterItem.points.forEach(point => {
                if (Array.isArray(point.fileItems)) {
                  sums.materialsFilesSum += point.fileItems.length;
                }
              });
            }
          });
        }
      });
    }
  }

  return sums.homeworksPhotosSum + sums.materialsFilesSum;
};
